import React, { useState } from "react";
import '../assets/styles/Configuracoes.css';

export default function Configuracoes() {
  const [activeTab, setActiveTab] = useState('sistema');

  return (
    <div>
      <h1>Painel de Configurações - SAR</h1>

      <div className="tabs">
        <div className={`tab${activeTab === 'sistema' ? ' active' : ''}`} onClick={() => setActiveTab('sistema')}>Sistema</div>
        <div className={`tab${activeTab === 'produtores' ? ' active' : ''}`} onClick={() => setActiveTab('produtores')}>Produtores</div>
        <div className={`tab${activeTab === 'notificacoes' ? ' active' : ''}`} onClick={() => setActiveTab('notificacoes')}>Notificações</div>
        <div className={`tab${activeTab === 'acessos' ? ' active' : ''}`} onClick={() => setActiveTab('acessos')}>Acessos</div>
        <div className={`tab${activeTab === 'integracoes' ? ' active' : ''}`} onClick={() => setActiveTab('integracoes')}>Integrações</div>
      </div>

      {/* SISTEMA */}
      {activeTab === 'sistema' && (
        <div className="tab-content active" id="sistema">
          <label>Ano Agrícola Atual</label>
          <input type="number" defaultValue="2025" />

          <label>Backup Automático</label>
          <select defaultValue="Semanal">
            <option>Semanal</option>
            <option>Mensal</option>
            <option>Desativado</option>
          </select>

          <div style={{ marginTop: 15 }}>
            <strong>Última verificação de atualização:</strong> 26/06/2025 - 14:23
            <br />
            <button style={{ marginTop: 10 }}>🔄 Verificar Agora</button>
          </div>

          <label style={{ marginTop: 20 }}>
            <input type="checkbox" defaultChecked /> Ativar modo manutenção
          </label>

          <div className="actions">
            <button>Salvar Configurações</button>
          </div>
        </div>
      )}

      {/* PRODUTORES */}
      {activeTab === 'produtores' && (
        <div className="tab-content active" id="produtores">
          

          <label>Permitir anexos no cadastro</label>
          <select defaultValue="Sim">
            <option>Sim</option>
            <option>Não</option>
          </select>

          <label>Quantidade máxima de propriedades por produtor</label>
          <input type="number" defaultValue="5" />

          <div className="actions">
            <button>Salvar Configurações</button>
          </div>
        </div>
      )}

      {/* NOTIFICAÇÕES */}
      {activeTab === 'notificacoes' && (
        <div className="tab-content active" id="notificacoes">
          <label>Mensagem de Alerta de Vacinação</label>
          <textarea rows={3} placeholder="Texto do alerta" defaultValue="Vacinação obrigatória até 30/06. Não perca o prazo!" />

          <label>Mensagem padrão de boas-vindas ao produtor</label>
          <textarea rows={2} placeholder="Mensagem de boas-vindas" defaultValue="Bem-vindo ao sistema agro municipal. Mantenha seus dados atualizados." />

          <label>Enviar notificação automática sobre nova safra?</label>
          <select defaultValue="Sim">
            <option>Sim</option>
            <option>Não</option>
          </select>

          <label>
            <input type="checkbox" defaultChecked /> Exibir alertas no painel principal
          </label>

          <div className="actions">
            <button>Salvar Notificações</button>
          </div>
        </div>
      )}

      {/* ACESSOS */}
      {activeTab === 'acessos' && (
        <div className="tab-content active" id="acessos">
          <div className="card">
            <h4>Administrador</h4>
            <label><input type="checkbox" defaultChecked /> Acesso completo</label>
            <label><input type="checkbox" defaultChecked /> Criar usuários</label>
            <label><input type="checkbox" defaultChecked /> Editar tudo</label>
          </div>

          <div className="card">
            <h4>Técnico</h4>
            <label><input type="checkbox" defaultChecked /> Registrar visitas</label>
            <label><input type="checkbox" defaultChecked /> Consultar dados</label>
          </div>

          <div className="card">
            <h4>Consultor</h4>
            <label><input type="checkbox" defaultChecked /> Leitura dos dados</label>
            <label><input type="checkbox" defaultChecked /> Visualizar gráficos</label>
          </div>

          <label style={{ marginTop: 20 }}>
            <input type="checkbox" defaultChecked /> Login obrigatório para acesso
          </label>

          <div className="actions">
            <button>Salvar Acessos</button>
          </div>
        </div>
      )}

      {/* INTEGRAÇÕES */}
      {activeTab === 'integracoes' && (
        <div className="tab-content active" id="integracoes">
          <label>API do Clima (OpenWeather)</label>
          <input type="text" defaultValue="*************" />

          <label>Cidade padrão</label>
          <input type="text" defaultValue="Ribeira do Pombal, BA" />

          <div className="actions">
            <button>Salvar Integrações</button>
          </div>
        </div>
      )}
    </div>
  );
}